import React, { useEffect, useState } from 'react'
import { Button, Tree, message, Input, Checkbox } from 'antd'
import { YhBox } from '@/components/YhBox'
import { FormBox } from './FormBox'
import { DataNode,  TreeProps } from 'antd/lib/tree'
import { useThreeTestItemModel } from '../threeTestItemModel'
import { IThreeTestItemDetail } from '../threeTestItemService'
const { Search } = Input
export const DataBox = () => {
    //查询条件
    const { treeSource,searchParam, setSearchParam,pruneTree,oldTreeSource,qzShow, setQzShow,compelTree, loadData, setMode, setSelectedNodes, selectedNodes, setFormVal, setTreeSource } = useThreeTestItemModel()

    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([])

    useEffect(() => {
        loadData(qzShow).then(() => {})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        // 更新expandedKeys以展开所有节点
        // 注意：这里为了简单起见，我们直接假设所有key都是已知的
        // 在实际应用中，你可能需要遍历newData来生成这个数组
        setExpandedKeys(Object.keys(treeSource.reduce((acc:any, node:any) => {
            acc[node.key] = true;
            if (node.children.length>0) {
                node.children.forEach((child:any) => {
                    acc[child.key] = true;
                    if (child.children.length>0) {
                        // 递归处理子节点
                        child.children.forEach((grandchild:any) => {
                            acc[grandchild.key] = true;
                        });
                    }
                });
            }
            return acc;
        }, {})));

    }, [treeSource]); // 空依赖数组表示这个effect只在组件挂载时运行一次


    //三检项目选中事件
    const onSelect = (
        _selectedKeys: React.Key[],
        info: {
            event: 'select'
            selected: boolean
            selectedNodes: DataNode[]
            nativeEvent: MouseEvent
        }
    ) => {
        let selectNode = info.selectedNodes as IThreeTestItemDetail[]
        setMode(info.selected ? 'edit' : '')
        setSelectedNodes(selectNode)
        // 添加车型图片信息到表单值中
        const nodeName = selectNode[0]?.name;
        let vehicleImage = '';
        if (nodeName === '吊机钢瓶车') {
            vehicleImage = '/public-static/chexing_diaojigangpingche.jpg';
        } else if (nodeName === '钢瓶车') {
            vehicleImage = '/public-static/chexing_gangpingche.jpg';
        } else if (nodeName === '买可保') {
            vehicleImage = '/public-static/chexing_maikebao.jpg';
        } else if (nodeName === '液体车') {
            vehicleImage = '/public-static/chexing_yetiche.jpg';
        } else if (nodeName === '直车') {
            vehicleImage = '/public-static/chexing_zhiche.jpg';
        }
        setFormVal({ ...selectNode[0], vehicleImage })
    }

    const onChangeCheckbox= (e:any) => {
        if(e){
            message.success('强制检查项模式开启！').then(() => {})
            setQzShow('compel')
            setSearchParam("")
            let newData=JSON.parse(JSON.stringify(oldTreeSource));
            compelTree(newData).then((result) => {
                setTreeSource(result)
            })
        }else{
            message.success('强制检查项模式关闭！').then(() => {})
            setQzShow('')
            loadData('').then((result) => {
                if(searchParam){
                    let newData=JSON.parse(JSON.stringify(result));
                    setTreeSource(pruneTree(newData,searchParam))
                }
            })
        }
    };


    const onExpand: TreeProps['onExpand'] = (expandedKeys) => {
        if (expandedKeys.length > 0) {
            setExpandedKeys(expandedKeys.map(e => e.toString()));
        }
        else {
            setExpandedKeys([]);
        }
    };
    return (
        <YhBox>
            <div className="dict-container flex">
                <div className="dict-list-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="dict-list-title">三检项目</span>
                        <div>
                            {qzShow==='compel'?
                                <Checkbox
                                    style={{color: '#fff',
                                        padding: '4px',
                                        marginRight: '17px',
                                        fontSize: '14px',
                                        height: '31px',
                                        borderRadius: '5px',
                                        backgroundColor: '#4062d8',}}
                                    onChange={()=>onChangeCheckbox(false)}
                                    checked={qzShow === 'compel'}
                                >强制检查项</Checkbox>:
                                <Button
                                    className="mr-5"
                                    type="primary"
                                    shape="round"
                                    onClick={() => {
                                        onChangeCheckbox(true)
                                    }}
                                >
                                    强制检查项
                                </Button>}
                        </div>
                    </div>
                    <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                        {/* <Input
                            prefix={<SearchOutlined className="site-form-item-icon" />}
                            placeholder="请输入回车检索"
                            size="small"
                            style={{ width: '100%' }}
                            value={searchParam?.value}
                            onChange={(e) => {
                                setSearchParam({ value: e.target.value })
                                let newData=JSON.parse(JSON.stringify(oldTreeSource));
                                setTreeSource(pruneTree(newData,e.target.value))
                            }}
                        /> */}
                        {qzShow===''&&
                            <Search
                                allowClear
                                placeholder="项目名称/项目编码"
                                defaultValue={searchParam}
                                style={{ width: '100%' }}
                                onSearch={
                                    (e) => {
                                        setSearchParam( e )
                                        let newData=JSON.parse(JSON.stringify(oldTreeSource));
                                        setTreeSource(pruneTree(newData,e))
                                    }} enterButton />}
                    </div>
                    {treeSource.length > 0 && (
                        <Tree
                            // expandedKeys={expandedKeys}
                            expandedKeys={expandedKeys}
                            onExpand={onExpand}
                            style={{height:'calc(100vh - 290px)',overflowY:'auto',border: '2px solid #f0f0f0',padding: '10px'}}
                            // defaultExpandedKeys={[selectedNodes[0]?.id]}
                            // selectedKeys={[selectedNodes[0]?.id]}
                            // //titleRender={(node: any) => `${node.name}`}
                            defaultExpandAll={true}
                            titleRender={(node: any) => (
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>{node.name}</span>
                                </div>
                            )}
                            blockNode
                            onSelect={onSelect}
                            treeData={treeSource}
                            expandAction={false}
                        />
                    )}
                </div>
                <div style={{ borderRight: '1px solid #e0e0e0', margin: '10px 0' }}></div>
                <div className="dict-from-box flex">
                    {selectedNodes.length > 0 ? <FormBox /> : <div className="dict-init-box flex flex-1 items-center justify-center">三检项目</div>}
                </div>
            </div>
        </YhBox>
    )
}